export const GOOGLE_ONE_TAP_ENV_VAR = 'NEXT_PUBLIC_ENABLE_GOOGLE_ONE_TAP'
export const GOOGLE_POPUP_ENV_VAR = 'NEXT_PUBLIC_ENABLE_GOOGLE_POPUP'

export type GoogleOneTapConfigOptions = {
  enableGoogleOneTap?: boolean
  includeGoogleOAuth?: boolean
}

/** Headless Google One Tap on login. Requires `NEXT_PUBLIC_ENABLE_GOOGLE_ONE_TAP=true`. */
export function isGoogleOneTapEnabled(): boolean {
  return process.env.NEXT_PUBLIC_ENABLE_GOOGLE_ONE_TAP === 'true'
}

/**
 * Google OAuth popup on login.
 * Real users need `NEXT_PUBLIC_ENABLE_GOOGLE_POPUP=true`. Playwright sets
 * `navigator.webdriver`, so e2e can cover the popup path while the flag stays
 * off for local and deployed apps.
 */
export function isGooglePopupEnabled(
  isWebdriver = typeof navigator !== 'undefined' && Boolean(navigator.webdriver),
): boolean {
  return process.env.NEXT_PUBLIC_ENABLE_GOOGLE_POPUP === 'true' || isWebdriver
}

export function resolvePatientGoogleOneTapConfig(options: GoogleOneTapConfigOptions = {}): {
  enableGoogleOneTap: boolean
  includeGoogleOAuth: boolean
} {
  const envEnabled = isGoogleOneTapEnabled()
  const enableGoogleOneTap = options.enableGoogleOneTap ?? envEnabled

  const includeGoogleOAuth =
    options.includeGoogleOAuth ??
    (options.enableGoogleOneTap === undefined ? true : enableGoogleOneTap)

  return { enableGoogleOneTap, includeGoogleOAuth }
}
